/* global google */
const maps = document.querySelectorAll('.js-map')

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @since   2022.1
 * @param   object item    The marker element.
 * @param   object map     The map instance.
 * @return  object         The marker instance.
 */
function initMarker(item, map) {
	// Get position from marker.
	const lat = item.getAttribute('data-lat')
	const lng = item.getAttribute('data-lng')
	const latLng = {
		lat: parseFloat(lat),
		lng: parseFloat(lng),
	}

	// Create marker instance.
	const marker = new google.maps.Marker({
		position: latLng,
		map,
	})

	// Append to reference for later use.
	map.markers.push(marker)

	// If marker contains HTML, add it to an infoWindow.
	if (item.innerHTML) {
		// Create info window.
		const infowindow = new google.maps.InfoWindow({
			content: item.innerHTML,
		})

		// Show info window when marker is clicked.
		google.maps.event.addListener(marker, 'click', () => {
			infowindow.open(map, marker)
		})
	}
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @since   2022.1
 * @param   object The map instance.
 * @return  void
 */
function centerMap(map) {
	// Create map boundaries from all map markers.
	const bounds = new google.maps.LatLngBounds()
	map.markers.forEach((marker) => {
		bounds.extend({
			lat: marker.position.lat(),
			lng: marker.position.lng(),
		})
	})

	// Case: Single marker.
	if (map.markers.length == 1) {
		map.setCenter(bounds.getCenter())

		// Case: Multiple markers.
	} else {
		map.fitBounds(bounds)
	}
}

/**
 * initMap
 *
 * Renders a Google Map onto the selected element
 *
 * @since   2022.1
 * @param   object e    The target element.
 * @return  object      The map instance.
 */
function initMap(e) {
	// Find marker elements within map.
	const markers = e.querySelectorAll('.js-marker')
	let zoom = e.getAttribute('data-zoom') || 16
	zoom = parseInt(zoom)

	// Create gerenic map.
	const mapArgs = {
		zoom,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: true,
		fullscreenControl: false,
	}
	const map = new google.maps.Map(e, mapArgs)

	// Add markers.
	map.markers = []
	markers.forEach((item) => {
		initMarker(item, map)
	})

	// Center map based on markers.
	centerMap(map)

	// Return map instance.
	return map
}

// Iniatialize map instances
if (maps) {
	maps.forEach((item) => {
		initMap(item)
	})
}
